import IconTurretRed from './IconTurretRed';

export default IconTurretRed;